export const SANITIZE_TEXT_REGEX = /[^a-zA-Z<>&@.-\d\s:]/g
export const PDP_REGEX = /^([\/]).*.([\-]).([0-9]{2,}).*$/gm
export const MEMBERSHIP_VALID_MAIL_ERROR_REGEX = /\S+@\S+\.\S+/
export const MEMBERSHIP_CODE_ERROR_REGEX = /@kohler.com\s*$/
export const FULL_NAME_REGEX = /^[a-zA-Z]+ [a-zA-Z]+$/
export const PURE_TEXT_REGEX = /<[^>]*>/g
export const SPECIAL_CHAR_REGEX = /[^a-zA-Zd0-9 ]/g
export const ALPHABET_WITH_SPACE_REGEX = /^[a-zA-Z ]+$/
